import { isTokenExpired } from '~/core/utils'
import { logError, logInfo } from '~/core/logger'

let axios

let isRefreshing = false
let pendingCalls = []

const onTokenRefreshed = accessToken => {
  logInfo({ __filename, pendingCalls }, 'Token refreshed.')
  pendingCalls.map(cb => cb(accessToken))
  pendingCalls = []
}

const verifyToken = async ({ config, onRefreshToken, onRefreshTokenError }) => {
  if (isRefreshing) {
    return new Promise(resolve => {
      const originalRequest = config
      pendingCalls.push(token => {
        originalRequest.currentToken = token
        originalRequest.headers.Authorization = `Bearer ${token}`
        resolve(originalRequest)
      })
    })
  }

  const { currentToken } = config
  const isExpired = isTokenExpired(currentToken)

  if (!isExpired) {
    return config
  }

  const newConfig = Object.assign({}, config)
  isRefreshing = true

  try {
    const { accessToken } = await onRefreshToken()
    newConfig.currentToken = accessToken
    newConfig.headers.Authorization = `Bearer ${accessToken}`
    isRefreshing = false
    onTokenRefreshed(accessToken)

    return newConfig
  } catch (err) {
    logError({ __filename, err }, 'An error occured while trying to retrieve updated session info.')

    onRefreshTokenError()
  }
}

const setup = ({ token, onRefreshToken, onRefreshTokenError = () => {}, checkForExpiry }) => {
  if (checkForExpiry) {
    axios.interceptors.request.use(
      config => verifyToken({ config, onRefreshToken, onRefreshTokenError })
    )
  }

  axios.interceptors.request.use(
    config => {
      const newConfig = Object.assign({ currentToken: token }, config)
      newConfig.headers.Authorization = `Bearer ${token}`

      return newConfig
    },

    error => Promise.reject(error)
  )
}

export const setAxios = lib => {
  axios = lib
}

export default {
  setup,
  get axios () {
    return axios
  }
}
